import React from 'react';
import PlanInfo from 'insurance/insurancePlans/PlanInfo';
import Box from 'common/Box';
import BottomButton from 'forms/BottomButton';
import Warning from 'notifications/Warning';
import styles from './ConfirmInsurance.module.css';

const ConfirmInsurance = ({ sku, insurancePlan, subId, deviceId, createPurchase }) => (
  <React.Fragment>
    <Box className={styles.ConfirmInsurance}>
      <PlanInfo insurancePlan={insurancePlan} />
      <BottomButton onClick={() => createPurchase(subId, sku, insurancePlan.sku, deviceId)}>Confirm</BottomButton>
    </Box>
    <Warning name="confirmInsurance" />
  </React.Fragment>
);

export default ConfirmInsurance;
